import React from "react";
import { Grid } from "@mui/material";
import * as SC from "./DataGrid.style";
import { ReactComponent as AscIcon } from "images/sort_asc.svg";
import { ReactComponent as DescIcon } from "images/sort_desc.svg";

const alignment = {
  center: "center",
  left: "start",
  right: "end",
};

export const DataGridHeader = ({
  columns,
  sorter,
  handleSort,
  visibility = [],
  isMobileWidth = false,
}) => {
  const visibleSize = {
    xs: 12,
    sm: 12,
    md: 12,
  };

  const getMdByField = (field) =>
    columns.find((item) => item.field === field)?.md ?? 0;

  if (!isMobileWidth && visibility.length > 0) {
    visibleSize.md = visibility.reduce(
      (acc, next) => acc + getMdByField(next),
      0
    );
    visibleSize.sm = visibleSize.md;
    visibleSize.xs = visibleSize.md;
  }

  return (
    <SC.Header container wrap={"wrap"} columns={visibleSize}>
      {columns.map(
        ({ label, field, xs, sm, md, align = "left" }) =>
          (isMobileWidth || visibility.length === 0 || visibility.includes(field)) && (
            <Grid key={`${label}-${field}`} item xs={xs} sm={sm} md={md}>
              {field ? (
                <SC.HeaderItem
                  onClick={() => handleSort(field)}
                  justifyContent={alignment[align]}
                >
                  {label}
                  {field === sorter.name && sorter.order === "asc" && (
                    <AscIcon width={isMobileWidth ? 12 : 24} />
                  )}
                  {field === sorter.name && sorter.order === "desc" && (
                    <DescIcon width={isMobileWidth ? 12 : 24} />
                  )}
                </SC.HeaderItem>
              ) : (
                <SC.HeaderItemWithoutSorter justifyContent={alignment[align]}>
                  {label}
                </SC.HeaderItemWithoutSorter>
              )}
            </Grid>
          )
      )}
    </SC.Header>
  );
};
